import { render } from "./IconButton.vue?vue&type=template&id=23bf5eef&scoped=true&ts=true"
import script from "./IconButton.vue?vue&type=script&lang=ts"
export * from "./IconButton.vue?vue&type=script&lang=ts"

import "./IconButton.vue?vue&type=style&index=0&id=23bf5eef&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webeye-pro-frontend/webeye-pro-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23bf5eef"]])

export default __exports__